// ユーザー詳細画面
$(() => {
    if (document.getElementById('client-user-revoke-invitation') != null) {
        $('.client-user-revoke-invitation-exec').on('click', function(e) {
            $('#client-user-revoke-invitation').submit();
        });
    }
});
